import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { getMe } from "../../services/api";

/**
 * Route guard: verifies the real backend session (httpOnly cookie) via
 * /api/auth/me before rendering protected content. localStorage alone is not
 * trusted — the server is the source of truth. On failure, redirect to /login.
 */
const RequireAuth = ({ children }) => {
  const [status, setStatus] = useState("checking"); // checking | authed | unauthed

  useEffect(() => {
    let active = true;
    getMe()
      .then((res) => {
        if (!active) return;
        // Keep the cached user in sync with the verified session.
        if (res?.data?.user) {
          localStorage.setItem("user", JSON.stringify(res.data.user));
        }
        setStatus("authed");
      })
      .catch(() => {
        if (!active) return;
        localStorage.removeItem("user");
        setStatus("unauthed");
      });
    return () => {
      active = false;
    };
  }, []);

  if (status === "checking") {
    return (
      <div className="flex min-h-screen items-center justify-center bg-ink-950 text-slate-400">
        <div className="flex items-center gap-3">
          <span className="h-5 w-5 animate-spin rounded-full border-2 border-white/20 border-t-accent-300" />
          <span className="text-sm">Checking your session…</span>
        </div>
      </div>
    );
  }

  if (status === "unauthed") {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default RequireAuth;
